import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Divider, FormCheckbox, ObjectSubscribersPanel } from "~/components/ModalObjects";
import { getProjectTemplateById } from "~/store/selectors/selector.projectTemplates.jsx";
import { TemplateTaskAssigneePicker } from "./TemplateTaskAssigneePicker.jsx";
import { TemplateTaskDatePicker } from "./TemplateTaskDatePicker";
import { TemplateTaskEstimatePicker } from "./TemplateTaskEstimatePicker";
import { TemplateTaskLabelPicker } from "./TemplateTaskLabelPicker";
import { TemplateTaskTaskListPicker } from "./TemplateTaskTaskListPicker";
import { PROJECT_TEMPLATE_TASK } from "../../utils.js";

export const TemplateTaskPanel = ({ task, onChange, className, fieldRef, type, isForm }) => {
  const { t } = useTranslation();
  const template = useSelector((state) => getProjectTemplateById(state, task.template_id));

  const handleChangeHiddenFromClients = (value) => {
    onChange({ is_hidden_from_clients: value });
  };

  const handleChangePriority = (value) => {
    onChange({ is_important: value });
  };

  return (
    <div className={className}>
      <TemplateTaskTaskListPicker
        task={task}
        onChange={onChange}
        fieldRef={fieldRef}
        type={type}
      />
      <TemplateTaskAssigneePicker
        task={task}
        onChange={onChange}
        isForm={isForm}
      />
      <TemplateTaskDatePicker
        task={task}
        onChange={onChange}
      />
      <TemplateTaskEstimatePicker
        task={task}
        onChange={onChange}
      />
      <TemplateTaskLabelPicker
        task={task}
        onChange={onChange}
      />
      <FormCheckbox
        id="template_task_panel_hidden_for_clients"
        checked={task.is_hidden_from_clients}
        onChange={handleChangeHiddenFromClients}
        text={t("Hidden from clients")}
      />
      <FormCheckbox
        id="template_task_panel_high_priority"
        checked={task.is_important}
        onChange={handleChangePriority}
        className="tw-mt-2"
        text={t("High priority")}
      />
      {!isForm ? (
        <>
          <Divider className="tw-my-6" />
          <ObjectSubscribersPanel
            parentType={type}
            parentId={task.id}
            members={template?.get(`members`)?.toJS()}
            hiddenFromClients={task.is_hidden_from_clients}
            canEdit
          />
        </>
      ) : null}
    </div>
  );
};

TemplateTaskPanel.propTypes = {
  task: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  fieldRef: PropTypes.object,
  type: PropTypes.string,
  isForm: PropTypes.bool,
};

TemplateTaskPanel.defaultProps = {
  type: PROJECT_TEMPLATE_TASK,
  isForm: false,
};
